module.exports = __webpack_public_path__ + "static/media/mv04.96b8bb20.jpg";